import type {CsrfResponse} from "@project/sdk/security";
import type {z} from "zod";

import {GetBffCsrfResponse} from "@project/sdk/security/zod";

export const authCsrfTokenSchema = GetBffCsrfResponse satisfies z.ZodType<CsrfResponse>;
